/**
 * @description 判斷案件來源為 網要、網投用
*/
export enum ApplyType {
  /** 網投 */
  WebInsured = 'C',
  /** 網要 */
  WebRequire = 'B'
}
